module.exports = __webpack_public_path__ + "static/linkplus-web-7ff73566cd0bd07ae13abdf8e8fd8672.jpg";